import React, { useState } from 'react';
import Sidebar from '../dashboard/Sidebar';
import TopBar from '../dashboard/TopBar';
import FeedbackBubble from '../feedback/FeedbackBubble';
import { Menu } from 'lucide-react';

interface AppLayoutProps {
  children: React.ReactNode;
}

export default function AppLayout({ children }: AppLayoutProps) {
  const [showMobileSidebar, setShowMobileSidebar] = useState(false);

  return (
    <div className="min-h-screen bg-background flex">
      {/* Mobile Sidebar Overlay */}
      {showMobileSidebar && (
        <div 
          className="fixed inset-0 bg-black/50 z-40 lg:hidden"
          onClick={() => setShowMobileSidebar(false)}
        />
      )}

      {/* Sidebar */}
      <div className={`
        fixed inset-y-0 left-0 z-50 lg:relative
        transform transition-transform duration-300 ease-in-out
        ${showMobileSidebar ? 'translate-x-0' : '-translate-x-full lg:translate-x-0'}
      `}>
        <Sidebar onClose={() => setShowMobileSidebar(false)} />
      </div>

      {/* Main Content */}
      <div className="flex-1 flex flex-col min-w-0">
        <TopBar>
          <button
            onClick={() => setShowMobileSidebar(true)}
            className="p-2 -ml-2 text-text-secondary hover:text-text-primary lg:hidden"
          >
            <Menu className="w-6 h-6" />
          </button>
        </TopBar>
        <main className="flex-1 overflow-auto">
          {children}
        </main>
      </div>

      {/* Feedback Bubble */}
      <FeedbackBubble />
    </div>
  );
}